import type { TAB_TYPES } from './constants/index.js';

import type { DSTabsT } from './react-desc-prop-types.js';

export namespace DSTabsInternalsT {
  export type TabTypesT = (typeof TAB_TYPES)[keyof typeof TAB_TYPES];

  export interface MobileGradientsT {
    right: boolean;
    left: boolean;
  }

  export interface ShowChevronsT {
    right: boolean;
    left: boolean;
  }
  export interface GlobalClickHandlerT {
    event: React.MouseEvent;
    target: 'panel' | 'tabItem' | 'tabsList' | 'swipeableViews';
    tabId?: string;
  }

  export interface DSTabsUseTabsContextT {
    props: DSTabsT.InternalProps;
    tabsRef: React.MutableRefObject<Record<number, HTMLButtonElement> | null>;
    focusableTabsRef: React.MutableRefObject<HTMLButtonElement[] | null>;
    tabsListRef: React.MutableRefObject<HTMLDivElement | null>;
    tabsRefAsArray: React.MutableRefObject<HTMLButtonElement[] | null>;
    actualActiveTabRef: React.MutableRefObject<HTMLButtonElement | null>;
    carouselOnlyListRef: React.MutableRefObject<HTMLDivElement | null>;
    setInternalActiveTab: React.Dispatch<React.SetStateAction<string>>;
    actualActiveTab: string;
    globalClickHandler: (data: GlobalClickHandlerT) => void;
    updateMobileGradients: () => void;
    mobileGradients: DSTabsInternalsT.MobileGradientsT;
    userDidChangeTabAtleastOnceRef: React.MutableRefObject<boolean>;
  }

  export interface DSTabsUseCrossRefContextT {
    lastTabInternalRef: React.MutableRefObject<HTMLButtonElement | null | undefined>;
    firstSubtabInternalRef: React.MutableRefObject<HTMLButtonElement | null | undefined>;
  }
}
